import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IrrigationStrategyTemplate } from '../../_models/irrigation/irrigationStrategyTemplate';
import { IrrigationStrategyZone } from '../../_models/irrigation/irrigationStrategyZone';

@Injectable()
export class IrrigationStrategyTemplateService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getIrrigationStrategyTemplate(weaving, commodityId) {
    // NB: weavig si intende la chiave che identifica della tessitura
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/irrigation/strategies?&isTemplate=true&weaving=' +
          weaving +
          '&commodityId=' +
          commodityId
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getCustomIrrigationStrategyTemplateList(): Observable<IrrigationStrategyTemplate[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/strategies').pipe(
      map((response) => {
        return response;
      })
    );
  }

  getCustomIrrigationStrategyTemplate(id: number): Observable<IrrigationStrategyTemplate> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/strategies/' + id).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTemplateStrategyForDetail(id: number) {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/strategyZones/' + id)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  saveStrategyZone(
    irrigationStrategyZoneItem: IrrigationStrategyZone
  ): Observable<IrrigationStrategyZone> {
    const irrigationStrategyZone = { ...irrigationStrategyZoneItem };
    delete irrigationStrategyZone.lastUpdated;
    delete irrigationStrategyZone.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    irrigationStrategyZone.companyId = companySelected ? companySelected.id : null;

    if (irrigationStrategyZone.id) {
      return this.http
        .put<IrrigationStrategyZone>(
          this.apiBaseUrl + 'api/private/v1/irrigation/strategyZones/' + irrigationStrategyZone.id,
          irrigationStrategyZone
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<IrrigationStrategyZone>(
          this.apiBaseUrl + 'api/private/v1/irrigation/strategyZones',
          irrigationStrategyZone
        )
        .pipe(map((response) => response));
    }
  }

  saveCustomIrrigationStrategyTemplate(
    item: IrrigationStrategyTemplate
  ): Observable<IrrigationStrategyTemplate> {
    const template = { ...item };
    delete template.lastUpdated;
    delete template.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    template.companyId = companySelected ? companySelected.id : null;

    if (template.id) {
      return this.http
        .put<IrrigationStrategyTemplate>(
          this.apiBaseUrl + 'api/private/v1/irrigation/strategies/' + template.id,
          template
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<IrrigationStrategyTemplate>(
          this.apiBaseUrl + 'api/private/v1/irrigation/strategies',
          template
        )
        .pipe(map((response) => response));
    }
  }

  deleteCustomIrrigationStrategyTemplate(
    template: IrrigationStrategyTemplate
  ): Observable<IrrigationStrategyTemplate> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/irrigation/strategies/' + template.id)
      .pipe(
        map((response) => {
          return { id: template.id } as IrrigationStrategyTemplate;
        })
      );
  }
}
